"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WanikaniCarousel = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _kyouElements = require("kyou-elements");

var _reactAwesomeSlider = _interopRequireDefault(require("react-awesome-slider"));

var _autoplay = _interopRequireDefault(require("react-awesome-slider/dist/autoplay"));

require("react-awesome-slider/dist/styles.css");

require("./slider.css");

require("react-awesome-slider/dist/custom-animations/cube-animation.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject6() {
  const data = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 50px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  const data = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 50px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  const data = _taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 200px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  const data = _taggedTemplateLiteral([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  color: white;\n  position: relative; // needed for Slider fillParent\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const AutoplaySlider = (0, _autoplay.default)(_reactAwesomeSlider.default);

const Container = _styledComponents.default.div(_templateObject());

const Slide = _styledComponents.default.div(_templateObject2());

const Card = _styledComponents.default.div(_templateObject3());

const Kanji = _styledComponents.default.div(_templateObject4());

const Meanings = _styledComponents.default.div(_templateObject5());

const Readings = _styledComponents.default.div(_templateObject6()); // TODO: If I can make multiple builds in this project, this can be an app that I can share with people. If it gets popular, I can promote benkyou that way. This should be 'wanikanidashboard.benkyou.app'
// TODO: changing the kanji slide should show a bottom indicator on the upper status panel.


const WanikaniCarousel = (_ref) => {
  let {
    isLoading,
    levelStatus
  } = _ref;
  const {
    levelKanji
  } = levelStatus;

  const renderKanji = kanji => {
    const {
      meaningsList,
      readingsList
    } = kanji;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: kanji.subjectId
    }, /*#__PURE__*/_react.default.createElement(Slide, {
      passed: kanji.passed
    }, /*#__PURE__*/_react.default.createElement(Card, null, /*#__PURE__*/_react.default.createElement(Kanji, null, kanji.characters), /*#__PURE__*/_react.default.createElement(Meanings, null, meaningsList.join(", ")), /*#__PURE__*/_react.default.createElement(Readings, null, readingsList.join(", ")))));
  };

  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_kyouElements.Render, {
    when: !isLoading
  }, () => {
    return /*#__PURE__*/_react.default.createElement(AutoplaySlider, {
      animation: "cubeAnimation",
      className: "raf-test",
      interval: 20 * 1000,
      bullets: false,
      organicArrows: false,
      play: true,
      infinite: true,
      fillParent: true
    }, levelKanji.map(renderKanji));
  }));
};

exports.WanikaniCarousel = WanikaniCarousel;
WanikaniCarousel.propTypes = {
  isLoading: _propTypes.default.bool.isRequired,
  levelStatus: _propTypes.default.shape({
    level: _propTypes.default.number,
    lessons: _propTypes.default.number,
    reviews: _propTypes.default.number,
    levelKanji: _propTypes.default.array,
    passedKanji: _propTypes.default.array,
    remainingKanji: _propTypes.default.array
  })
};